<div class="partitions-view">
    <aside *ngIf="simulation" class="col partitions-block">
        <app-partitions-sunburst-card class="sunburst" [mainPartition]="mainPartition" [selected]="selectedPartition"
            [year]="previousYear"></app-partitions-sunburst-card>

        <mat-card class="actions">
            <button mat-raised-button color="accent" (click)="onValidate()"
                matTooltip="{{'partitions.buttons.apply.summary' | translate}}">
                <mat-icon aria-label="Calculate">play_arrow</mat-icon>
                {{'partitions.buttons.apply.shortLabel' | translate}}
            </button>
            <a mat-button matTooltip="{{'partitions.buttons.cancel.summary' | translate}}"
                [routerLink]="backLink.route">
                <mat-icon aria-label="Back">{{ backLink.icon }}</mat-icon>
                {{'partitions.buttons.cancel.shortLabel' | translate}}
            </a>
            <a mat-button *ngIf="paramLink" [routerLink]="paramLink.route">
                <mat-icon aria-label="Parameters">{{ paramLink.icon }}</mat-icon>
                {{ paramLink.title | translate }}
            </a>
        </mat-card>

        <app-partitions-tree-card class="tree" [partitions]="partitionsTree" [selectedNode]="selectedPartition">
        </app-partitions-tree-card>
    </aside>

    <section *ngIf="selectedPartition" class="col partition-detail-block">
        <mat-card class="partition-actions">
            <mat-card-header>
                <mat-card-title>
                    <app-breadcrumb [breadcrumbArray]="breadcrumbArray"></app-breadcrumb>
                </mat-card-title>
            </mat-card-header>
            <mat-card-content *ngIf="selectedPartition.isEditable">
                <div>
                    <button mat-raised-button color="accent" (click)="onReset()"
                        matTooltip="{{(simulation.isMJP ?
                            'partitions.reset.title.mjp.summary' :
                            'partitions.reset.title.default.summary') | translate}}">
                        <mat-icon aria-label="Refresh">refresh</mat-icon>
                        {{(simulation.isMJP ?
                            'partitions.reset.title.mjp.fullLabel' :
                            'partitions.reset.title.default.fullLabel') | translate}}
                    </button>
                </div>
            </mat-card-content>
            <mat-card-content *ngIf="!selectedPartition.isEditable">
                <p class="not-editable">{{'partitions.notEditable.summary' | translate}}</p>
            </mat-card-content>
        </mat-card>

        <ng-container *ngIf="selectedPartition.isEditable">
            <app-evolution-parameter *ngIf="!simulation.isNullMJP" class="evolution-parameter"
                [projectionRate]="selectedPartition.projectionRate"
                [statisticalsRates]="selectedPartition.statisticalsRates"
                [macroRates]="selectedPartition.macroRates"
                [globalRates]="selectedPartition.globalRates"
                [partition]="selectedPartition"
                [isMJP]="simulation.isMJP"
                [isNullMJP]="simulation.isNullMJP"></app-evolution-parameter>

            <ng-container *ngIf="!simulation.isMJP">
                <app-partition-cursors-chart class="cursors-chart" [partition]="selectedPartition"></app-partition-cursors-chart>

                <app-partition-cursors class="partition-cursors"
                    [simulation]="selectedPartition.simulationValues"
                    [cursor]="selectedPartition.cursorParameters"
                    [projectionRate]="selectedPartition.projectionRate"></app-partition-cursors>
            </ng-container>

            <ng-container *ngIf="simulation.isMJP">
                <app-partition-cursors-chart-mjp class="cursors-chart" [partition]="selectedPartition"></app-partition-cursors-chart-mjp>

                <app-partition-cursors-mjp class="partition-cursors"
                    [simulation]="selectedPartition.simulationValues"
                    [cursor]="selectedPartition.cursorParameters"
                    [projectionRate]="selectedPartition.projectionRate"></app-partition-cursors-mjp>
            </ng-container>
        </ng-container>
    </section>

    <section *ngIf="!selectedPartition" class="col">
        <mat-card>
            <p class="not-selected">{{'partitions.notSelected.summary' | translate}}</p>
        </mat-card>
    </section>
</div>
<div class="mobile-message">
    <p>{{'main.mobileMessage.summary' | translate}}</p>
</div>
